import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment'; // Importa el entorno
import { ApiRoutesEnum } from '../enums/ApiRoutes.enum';
import { Login } from 'src/app/models/Login.model';
import { CustomerResponse, FunctionalityRoleResponse, LoginResponse, StateResponse, ListPlansResponse, PlanResponse, ResponseDataBoolean, ListDevicesResponse, ResponsePlansByUserDTO, DeviceResponse, ResponseDataNumber, ResponseListPlanDeviceDTO, ListPartnersResponse, PartnerResponse, ResponseListUserPartnerDTO, ResponseListTransferPartnerDTO, ResponseSimpleRequestString, ResponseCustomerSummaryDTO, ResponsePartnerSummaryDTO, ResponseTDeviceUsageDTO, ResponseRoleDTO, UserManagementResponse, ListUsersResponse, SimpleResponseRoleDTO, ResponseListModuleByRole, ResponseDataFile, NotificationResponse, ResponseDataDecimal, RatePlansResponse, SimResponse, ListSimsResponse, ListPlanAvailableDTO, LisStatusSimResponse, ListCarriersResponse, LogCallbackResponse, GetCurrentUserResponse } from '../models/ApiResponse';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { PlanDTO } from 'src/app/models/PlanDTO.model';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { UserRequestDTO } from '../models/UserRequestDto';
import { UserPlanDevDTO } from 'src/app/models/UserPlanDevDTO.model';
import { PlanByUserDTO } from 'src/app/models/PlanByUserDTO.model';
import { PlanDeviceDTO } from 'src/app/models/PlanDeviceDTO.model';
import { SimpleRequestDTO } from '../models/SimpleRequest';
import { SimpleRequestString } from '../models/SimpleRequestString';
import { UserGroupDTO } from 'src/app/models/UserGroupDTO.model';
import { UserManagementDTO } from 'src/app/models/UserManagementDTO.model';
import { RoleDTO } from 'src/app/models/RoleDTO.model';
import { ModuleByRoleDTO } from 'src/app/models/ModuleByRoleDTO.model';
import { SimpleRequestLongList } from '../models/SimpleRequestLongList';
import { CustomerPlanSummaryDTO } from 'src/app/models/CustomerPlanSummaryDTO.model';
import { NotificationDTO } from 'src/app/models/NotificationDTO.model';
import { FileDTO } from 'src/app/models/FileDTO.model';
import { ApiResponse } from 'src/app/models/ApiResponse';
import { AwaitableObservable, createAwaitableApiResponse } from '../AwaitableObservable';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private readonly baseUrl: string;

  private alertService = inject(AlertService);

  constructor(private http: HttpClient) {

    this.baseUrl = environment.API_URL;

    const localServerPort: any = environment.LOCAL_SERVER_PORT;

    if (localServerPort && environment.API_URL_FOR_LOCAL_SERVER) {
      let currentPort = '80';
      let arr = document.location.host.split(':');
      if (arr.length > 1) {
        currentPort = arr[arr.length - 1];
      }
      if (currentPort === localServerPort.toString()) {
        this.baseUrl = environment.API_URL_FOR_LOCAL_SERVER;
      }
    }
  }

  getHeaders(): { headers: HttpHeaders } {
    const token = localStorage.getItem('JWT');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers,
    };

    return httpOptions;
  }

  getHeadersWithParams(params : HttpParams): { headers: HttpHeaders } {
    const token = localStorage.getItem('JWT');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers,
      params: params
    };

    return httpOptions;
  }

  login(data: Login): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      this.baseUrl + ApiRoutesEnum.LOGIN,
      data
    );
  }

  getFuncionalities(): Observable<FunctionalityRoleResponse> {
    return this.http.get<FunctionalityRoleResponse>(
      this.baseUrl + ApiRoutesEnum.FUNCIONALITIES,
      this.getHeaders()
    );
  }

  getMastersById(data: MasterdataRequestDTO): Observable<StateResponse> {
    return this.http.post<StateResponse>(
      this.baseUrl + ApiRoutesEnum.GET_MASTERS_BY_ID,
      data,
      this.getHeaders()
    );
  }

  getMastersByName(data: MasterdataRequestDTO): Observable<StateResponse> {
    return this.http.post<StateResponse>(
      this.baseUrl + ApiRoutesEnum.GET_MASTERS_BY_NAME,
      data,
      this.getHeaders()
    );
  }

  saveCustomer(data: UserDTO): Observable<CustomerResponse> {
    return this.http.post<CustomerResponse>(
      this.baseUrl + ApiRoutesEnum.SAVE_CUSTOMER,
      data,
      this.getHeaders()
    );
  }

  saveCustomerUser(data: UserDTO): Observable<CustomerResponse> {
    return this.http.post<CustomerResponse>(
      this.baseUrl + ApiRoutesEnum.SAVE_CUSTOMER_USER,
      data,
      this.getHeaders()
    );
  }

  createUserStaff(data: UserDTO): Observable<CustomerResponse> {
    return this.http.post<CustomerResponse>(
      this.baseUrl + ApiRoutesEnum.CREATE_USER_STAFF,
      data,
      this.getHeaders()
    );
  }

  createDistributorCustomer(data: UserDTO): Observable<CustomerResponse> {
    return this.http.post<CustomerResponse>(
      this.baseUrl + ApiRoutesEnum.CREATE_DISTRIBUTOR_CUSTOMER,
      data,
      this.getHeaders()
    );
  }
  
  getCurrentUser(): Observable<GetCurrentUserResponse> {
    return this.http.post<GetCurrentUserResponse>(
      this.baseUrl + ApiRoutesEnum.GET_CURRENT_USER,
      null,
      this.getHeaders()
    );
  }

  getListCustomers(): Observable<ListUsersResponse> {
    return this.http.post<ListUsersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_CUSTOMERS,
      null,
      this.getHeaders()
    );
  }

  getPercentageAlertByUser(): Observable<CustomerResponse> {
    return this.http.post<CustomerResponse>(
      this.baseUrl + ApiRoutesEnum.GET_PERCENTEGE_ALERT_BY_USER,
      null,
      this.getHeaders()
    );
  }

  getListUsersManagement(): Observable<ListUsersResponse> {
    return this.http.post<ListUsersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_USERS_MANAGEMENT,
      null,
      this.getHeaders()
    );
  }

  updateCustomerStatus(data: UserDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_CUSTOMER_STATUS,
      data,
      this.getHeaders()
    );
  }

  updateUserPercentageAlert(data: CustomerPlanSummaryDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_USER_PERCENTAGE_ALERT,
      data,
      this.getHeaders()
    );
  }






  updateCustomer(data: UserDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_CUSTOMER,
      data,
      this.getHeaders()
    );
  }

  getUserById(data: UserRequestDTO): Observable<CustomerResponse> {
    return this.http.post<CustomerResponse>(
      this.baseUrl + ApiRoutesEnum.GET_USER_BY_ID,
      data,
      this.getHeaders()
    );
  }



  getAllPlansAssignPlan(): Observable<ListPlansResponse> {
    return this.http.post<ListPlansResponse>(
      this.baseUrl + ApiRoutesEnum.GET_ALL_PLANS_ASSIGN_PLAN,
      null,
      this.getHeaders()
    );
  }

  getPlansByUserId(data: UserRequestDTO): Observable<ResponsePlansByUserDTO> {
    return this.http.post<ResponsePlansByUserDTO>(
      this.baseUrl + ApiRoutesEnum.GET_PLANS_BY_USERID,
      data,
      this.getHeaders()
    );
  }

  getListUsersOfCustomer(data: UserRequestDTO): Observable<ListUsersResponse> {
    return this.http.post<ListUsersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_USERS_OF_CUSTOMER,
      data,
      this.getHeaders()
    );
  }

  getListUsersOfStaff(data: UserRequestDTO): Observable<ListUsersResponse> {
    return this.http.post<ListUsersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_USERS_OF_STAFF,
      data,
      this.getHeaders()
    );
  }

  getListCustomersOfDistributor(data: UserRequestDTO): Observable<ListUsersResponse> {
    return this.http.post<ListUsersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_CUSTOMERS_OF_DISTRIBUTOR,
      data,
      this.getHeaders()
    );
  }
  
  updateUserPlanStatus(data: PlanByUserDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_USER_PLAN_STATUS,
      data,
      this.getHeaders()
    );
  }

  getListDevices(): Observable<ListDevicesResponse> {
    return this.http
      .get<ListDevicesResponse>(this.baseUrl + ApiRoutesEnum.GET_LIST_DEVICES, this.getHeaders());
  }

  getDeviceByICCID(data: DeviceDTO): Observable<DeviceResponse> {
    return this.http.post<DeviceResponse>(
      this.baseUrl + ApiRoutesEnum.GET_DEVICE_BY_ICCID,
      data,
      this.getHeaders()
    );
  }

  createDevice(data: DeviceDTO): Observable<ResponseDataNumber> {
    return this.http.post<ResponseDataNumber>(
      this.baseUrl + ApiRoutesEnum.CREATE_DEVICE,
      data,
      this.getHeaders()
    );
  }

  updateDevice(data: DeviceDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_DEVICE,
      data,
      this.getHeaders()
    );
  }

  createPlanDevice(data: PlanDeviceDTO): Observable<ResponseDataNumber> {
    return this.http.post<ResponseDataNumber>(
      this.baseUrl + ApiRoutesEnum.CREATE_PLAN_DEVICE,
      data,
      this.getHeaders()
    );
  }

  getDevicesPlanByIdPlan(data: SimpleRequestDTO): Observable<ResponseListPlanDeviceDTO> {
    return this.http.post<ResponseListPlanDeviceDTO>(
      this.baseUrl + ApiRoutesEnum.GET_DEVICES_PLAN_BY_ID_PLAN,
      data,
      this.getHeaders()
    );
  }

  updatePlanDeviceStatus(data: PlanDeviceDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_PLAN_DEVICE_STATUS,
      data,
      this.getHeaders()
    );
  }

  getListPartners(): Observable<ListPartnersResponse> {
    return this.http.get<ListPartnersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_PARTNERS,
      this.getHeaders()
    );
  }

  savePartner(data: UserDTO): Observable<PartnerResponse> {
    return this.http.post<PartnerResponse>(
      this.baseUrl + ApiRoutesEnum.SAVE_PARTNER,
      data,
      this.getHeaders()
    );
  }


  validateEmailExist(data: SimpleRequestString): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.VALIDATE_EMAIL_EXIST,
      data,
      this.getHeaders()
    );
  }

  updatePassword(data: UserDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_PASSWORD,
      data,
      this.getHeaders()
    );
  }

  getListCustomersByPartnerId(data: SimpleRequestDTO): Observable<ResponseListUserPartnerDTO> {
    return this.http.post<ResponseListUserPartnerDTO>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_CUSTOMERS_BY_PARTNER_ID,
      data,
      this.getHeaders()
    );
  }

  getListCustomersAvailables(): Observable<ResponseListUserPartnerDTO> {
    return this.http.get<ResponseListUserPartnerDTO>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_CUSTOMERS_AVAILABLES,
      this.getHeaders()
    );
  }

  addCustomersPartner(data: UserGroupDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.ADD_CUSTOMERS_PARTNER,
      data,
      this.getHeaders()
    );
  }

  clearCustomersPartner(data: SimpleRequestDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.CLEAR_CUSTOMERS_PARTNER,
      data,
      this.getHeaders()
    );
  }

  getAllPartnersAvailables(): Observable<ResponseListTransferPartnerDTO> {
    return this.http.get<ResponseListTransferPartnerDTO>(
      this.baseUrl + ApiRoutesEnum.GET_ALL_PARTNERS_AVAILABLES,
      this.getHeaders()
    );
  }

  updateCustomersPartner(data: UserGroupDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_CUSTOMERS_PARTNER,
      data,
      this.getHeaders()
    );
  }

  getListDistributors(): Observable<ListPartnersResponse> {
    return this.http.get<ListPartnersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_DISTRIBUTORS,
      this.getHeaders()
    );
  }

  saveDistributor(data: UserDTO): Observable<PartnerResponse> {
    return this.http.post<PartnerResponse>(
      this.baseUrl + ApiRoutesEnum.SAVE_DISTRIBUTOR,
      data,
      this.getHeaders()
    );
  }

  getListPartnersByDistributorId(data: SimpleRequestDTO): Observable<ResponseListUserPartnerDTO> {
    return this.http.post<ResponseListUserPartnerDTO>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_PARTNERS_BY_DISTRIBUTOR_ID,
      data,
      this.getHeaders()
    );
  }

  getListPartnersAvailables(): Observable<ResponseListUserPartnerDTO> {
    return this.http.get<ResponseListUserPartnerDTO>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_PARTNERS_AVAILABLES,
      this.getHeaders()
    );
  }

  addPartnersDistributor(data: UserGroupDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.ADD_PARTNERS_DISTRIBUTOR,
      data,
      this.getHeaders()
    );
  }

  clearPartnersDistributor(data: SimpleRequestDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.CLEAR_PARTNERS_DISTRIBUTOR,
      data,
      this.getHeaders()
    );
  }

  getAllDistributorsAvailables(): Observable<ResponseListTransferPartnerDTO> {
    return this.http.get<ResponseListTransferPartnerDTO>(
      this.baseUrl + ApiRoutesEnum.GET_ALL_DISTRIBUTORS_AVAILABLES,
      this.getHeaders()
    );
  }

  updatePartnersDistributor(data: UserGroupDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_PARTNERS_DISTRIBUTOR,
      data,
      this.getHeaders()
    );
  }

  getDistributorSummary(data: SimpleRequestDTO): Observable<ResponsePartnerSummaryDTO> {
    return this.http.post<ResponsePartnerSummaryDTO>(
      this.baseUrl + ApiRoutesEnum.GET_DISTRIBUTORS_SUMMARY,
      data,
      this.getHeaders()
    );
  }

  verifyCode(data: SimpleRequestString): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.VERIFY_CODE,
      data,
      this.getHeaders()
    );
  }

  getUserByEmail(data: SimpleRequestString): Observable<ResponseSimpleRequestString> {
    return this.http.post<ResponseSimpleRequestString>(
      this.baseUrl + ApiRoutesEnum.GET_USER_BY_EMAIL,
      data,
      this.getHeaders()
    );
  }

  resendVerificationCode(data: SimpleRequestString): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.RESEND_VERIFICATION_CODE,
      data,
      this.getHeaders()
    );
  }

  sendVerificationEmail(data: SimpleRequestString): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.SEND_VERIFICATION_EMAIL,
      data,
      this.getHeaders()
    );
  }

  verifyCodeEmail(data: SimpleRequestString): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.VERIFIY_CODE_EMAIL,
      data,
      this.getHeaders()
    );
  }

  getAllPlansTypePlan(data: SimpleRequestString): Observable<ListPlansResponse> {
    return this.http.post<ListPlansResponse>(
      this.baseUrl + ApiRoutesEnum.GET_ALL_PLANS_TYPE_PLAN,
      data,
      this.getHeaders()
    );
  }

  // updateUserPlan(data: UserPlanDevDTO): Observable<ResponseDataBoolean> {
  //   return this.http.post<ResponseDataBoolean>(
  //     this.baseUrl + ApiRoutesEnum.UPDATE_USER_PLAN,
  //     data,
  //     this.getHeaders()
  //   );
  // }

  /*
  getUserSummary(data: SimpleRequestDTO): Observable<ResponseCustomerSummaryDTO> {
    return this.http.post<ResponseCustomerSummaryDTO>(
      this.baseUrl + ApiRoutesEnum.GET_USER_SUMMARY,
      data,
      this.getHeaders()
    );
  }
  */

  getPartnerSummary(data: SimpleRequestDTO): Observable<ResponsePartnerSummaryDTO> {
    return this.http.post<ResponsePartnerSummaryDTO>(
      this.baseUrl + ApiRoutesEnum.GET_PARTNERS_SUMMARY,
      data,
      this.getHeaders()
    );
  }

  getAllUsagesByIdPlan(data: SimpleRequestDTO): Observable<ResponseTDeviceUsageDTO> {
    return this.http.post<ResponseTDeviceUsageDTO>(
      this.baseUrl + ApiRoutesEnum.GET_ALL_USAGES_BY_ID_PLAN,
      data,
      this.getHeaders()
    );
  }

  getRoles(): Observable<ResponseRoleDTO> {
    return this.http.post<ResponseRoleDTO>(
      this.baseUrl + ApiRoutesEnum.GET_ROLES,
      null,
      this.getHeaders()
    );
  }

  saveUserManagement(data: UserManagementDTO): Observable<UserManagementResponse> {
    return this.http.post<UserManagementResponse>(
      this.baseUrl + ApiRoutesEnum.SAVE_USER_MANAGEMENT,
      data,
      this.getHeaders()
    );
  }

  updateUserManagement(data: UserManagementDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_USER_MANAGEMENT,
      data,
      this.getHeaders()
    );
  }

  getListRoles(): Observable<ResponseRoleDTO> {
    return this.http.post<ResponseRoleDTO>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_ROLES,
      null,
      this.getHeaders()
    );
  }

  getRoleById(request: SimpleRequestDTO): Observable<SimpleResponseRoleDTO> {
    return this.http.post<SimpleResponseRoleDTO>(
      this.baseUrl + ApiRoutesEnum.GET_ROLE_BY_ID,
      request,
      this.getHeaders()
    );
  }

  updateRoleStatus(data: RoleDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_ROLE_STATUS,
      data,
      this.getHeaders()
    );
  }

  createRole(data: RoleDTO): Observable<ResponseDataNumber> {
    return this.http.post<ResponseDataNumber>(
      this.baseUrl + ApiRoutesEnum.CREATE_ROLE,
      data,
      this.getHeaders()
    );
  }

  updateRole(data: RoleDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_ROLE,
      data,
      this.getHeaders()
    );
  }

  getModuleByRole(data: SimpleRequestDTO): Observable<ResponseListModuleByRole> {
    return this.http.post<ResponseListModuleByRole>(
      this.baseUrl + ApiRoutesEnum.GET_MODULE_BY_ROLE,
      data,
      this.getHeaders()
    );
  }

  updateModuleByRole(data: ModuleByRoleDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_MODULE_BY_ROLE,
      data,
      this.getHeaders()
    );
  }

  updatePlanDevice(data: PlanDeviceDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_PLAN_DEVICE,
      data,
      this.getHeaders()
    );
  }

  exportCustomersListToExcel(): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_CUSTOMERS,
      null,
      this.getHeaders()
    );
  }

  exportToExcelListDevices(): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_DEVICES,
      null,
      this.getHeaders()
    );
  }

  exportToExcelListPlanDevices(data: SimpleRequestDTO): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_PLAN_DEVICES,
      data,
      this.getHeaders()
    );
  }

  exportToExcelListPlanDevicesAnnual(data: SimpleRequestDTO): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_PLAN_DEVICES_ANNUAL,
      data,
      this.getHeaders()
    );
  }

  exportToExcelListPlanDevicesConsolidated(data: SimpleRequestLongList): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_PLAN_DEVICES_CONSOLIDATED,
      data,
      this.getHeaders()
    );
  }

  exportPlansListToExcel(): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_PLANS,
      null,
      this.getHeaders()
    );
  }

  exportToExcelListCustomerPlans(data: UserRequestDTO): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_CUSTOMER_PLANS,
      data,
      this.getHeaders()
    );
  }

  exportToExcelListPartners(): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_PARTNERS,
      null,
      this.getHeaders()
    );
  }

  exportToExcelListDistributors(): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_DISTRIBUTORS,
      null,
      this.getHeaders()
    );
  }

  exportToExcelListDistributorPartners(data: SimpleRequestDTO): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_PARTNERS_BY_DISTRIBUTORID,
      data,
      this.getHeaders()
    );
  }

  exportToExcelListUsersManagement(): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_USERS_MANAGEMENT,
      null,
      this.getHeaders()
    );
  }
  
  exportToExcelListPartnerCustomers(data: SimpleRequestDTO): Observable<ResponseDataFile> {
    return this.http.post<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.EXPORT_TO_EXCEL_LIST_CUSTOMERS_BY_PARTNERID,
      data,
      this.getHeaders()
    );
  }

  createNotification(data: NotificationDTO): Observable<NotificationResponse> {
    return this.http.post<NotificationResponse>(
      this.baseUrl + ApiRoutesEnum.CREATE_NOTIFICATION,
      data,
      this.getHeaders()
    );
  }

  getNotification(): Observable<NotificationResponse> {
    return this.http.post<NotificationResponse>(
      this.baseUrl + ApiRoutesEnum.GET_NOTIFICATION,
      null,
      this.getHeaders()
    );
  }

  calculateProrationStart(data: UserPlanDevDTO): Observable<ResponseDataDecimal> {
    return this.http.post<ResponseDataDecimal>(
      this.baseUrl + ApiRoutesEnum.CALCULATE_PRORATION_START,
      data,
      this.getHeaders()
    );
  }

  calculateProrationEnd(data: UserPlanDevDTO): Observable<ResponseDataDecimal> {
    return this.http.post<ResponseDataDecimal>(
      this.baseUrl + ApiRoutesEnum.CALCULATE_PRORATION_END,
      data,
      this.getHeaders()
    );
  }

  getRatePlans(): Observable<RatePlansResponse> {
    return this.http.post<RatePlansResponse>(
      this.baseUrl + ApiRoutesEnum.GET_RATE_PLANS,
      null,
      this.getHeaders()
    );
  }



  getListSims(): Observable<ListSimsResponse> {
    return this.http.post<ListSimsResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_SIMS,
      null,
      this.getHeaders()
    );
  }

  updateSimStatus(data: DeviceDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.UPDATE_SIM_STATUS,
      data,
      this.getHeaders()
    );
  }

 

  getListSimsAvailables(): Observable<ListSimsResponse> {
    return this.http.post<ListSimsResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LIST_SIMS_AVAILABLES,
      null,
      this.getHeaders()
    );
  }

  addDevicesToPlan(data: PlanDeviceDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(
      this.baseUrl + ApiRoutesEnum.ADD_DEVICES_TO_PLAN,
      data,
      this.getHeaders()
    );
  }


  getStatusSims(): Observable<LisStatusSimResponse> {
    return this.http.post<LisStatusSimResponse>(
      this.baseUrl + ApiRoutesEnum.GET_STATUS_SIMS,
      null,
      this.getHeaders()
    );
  }

  getCarriers(): Observable<ListCarriersResponse> {
    return this.http.post<ListCarriersResponse>(
      this.baseUrl + ApiRoutesEnum.GET_CARRIERS,
      null,
      this.getHeaders()
    );
  }

  getLogsCalback(data: DeviceDTO): Observable<LogCallbackResponse> {
    return this.http.post<LogCallbackResponse>(
      this.baseUrl + ApiRoutesEnum.GET_LOGS_CALLBACK,
      data,
      this.getHeaders()
    );
  }

  getTemplateCreateInventory(): Observable<ResponseDataFile> {
    return this.http.get<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.GET_TEMPLATE_CREATE_INVENTORY,
      this.getHeaders()
    );
  }

  getTemplateUpdateInventory(): Observable<ResponseDataFile> {
    return this.http.get<ResponseDataFile>(
      this.baseUrl + ApiRoutesEnum.GET_TEMPLATE_UPDATE_INVENTORY,
      this.getHeaders()
    );
  }

  get<T>(url: string, params?: any): Observable<T> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<ApiResponse<T>>(this.baseUrl + url, this.getHeadersWithParams(httpParams)).pipe(
        map((response) => response.Data) // Extract Data
      );
  }

  post<T>(url: string, body: any): Observable<T> {
    return this.http.post<ApiResponse<T>>(this.baseUrl + url, body, this.getHeaders()).pipe(
      map((response) => response.Data) // Extract Data
      );
  }

  put<T>(url: string, body: any): Observable<T> {
    return this.http.put<ApiResponse<T>>(this.baseUrl+url, body, this.getHeaders()).pipe(
        map((response) => response.Data) // Extract Data
      );
  }

  patch<T>(url: string, body: any): Observable<T> {
    return this.http.patch<ApiResponse<T>>(this.baseUrl + url, body, this.getHeaders()).pipe(
        map((response) => response.Data) // Extract Data
      );
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<ApiResponse<T>>(this.baseUrl + url, this.getHeaders()).pipe(
        map((response) => response.Data) // Extract Data
      );
  }





  getAsync<T>(url: string, params?: any): AwaitableObservable<T> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.alertService.createAwaitableApiResponse(this.http.get<ApiResponse<T>>(this.baseUrl + url, this.getHeadersWithParams(httpParams)));
  }

  postAsync<T>(url: string, body?: any): AwaitableObservable<T> {
    return this.alertService.createAwaitableApiResponse(this.http.post<ApiResponse<T>>(this.baseUrl + url, body, this.getHeaders()));
  }

  putAsync<T>(url: string, body: any): AwaitableObservable<T> {
    return this.alertService.createAwaitableApiResponse(this.http.put<ApiResponse<T>>(this.baseUrl + url, body, this.getHeaders()));
  }

  patchAsync<T>(url: string, body: any): AwaitableObservable<T> {
    return this.alertService.createAwaitableApiResponse(this.http.patch<ApiResponse<T>>(this.baseUrl + url, body, this.getHeaders()));
  }

  deleteAsync<T>(url: string): AwaitableObservable<T> {
    return this.alertService.createAwaitableApiResponse(this.http.delete<ApiResponse<T>>(this.baseUrl + url, this.getHeaders()));
  }


  addCustomersDistributor(data: UserGroupDTO[]): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(this.baseUrl + ApiRoutesEnum.ADD_CUSTOMERS_DISTRIBUTOR, data, this.getHeaders());
  }

  clearCustomersDistributor(data: SimpleRequestDTO): Observable<ResponseDataBoolean> {
    return this.http.post<ResponseDataBoolean>(this.baseUrl + ApiRoutesEnum.CLEAR_CUSTOMERS_DISTRIBUTOR, data, this.getHeaders());
  }

}
